import { OrderedRow } from '../models/priceRows.model';

export const visibleRows = (rows: OrderedRow[], pricedIds: Set<string>) =>
  rows.filter(row => row.kind !== 'price' || pricedIds.has(row.id));

// Drag indexes count rendered rows; rows hidden from the table keep their slot in the order.
export const movePriceField = (
  fullOrder: string[],
  renderedIds: string[],
  sourceIndex: number,
  destinationIndex: number,
): string[] => {
  const moved = [...renderedIds];
  const [movedId] = moved.splice(sourceIndex, 1);
  moved.splice(destinationIndex, 0, movedId);

  const rendered = new Set(renderedIds);
  let next = 0;
  return fullOrder.map(id => (rendered.has(id) ? moved[next++] : id));
};
